import React from 'react';
import styled from 'styled-components';
import BuildVersion from '../../atoms/BuildVersion';

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background-color: #5c5c5c;
  color: #ffffff;
  padding: 25px 0;
`;

function Footer() {
  const linkPrivacidade =
    'https://drive.google.com/file/d/1hM7Cg1uEcI1NN8qLMh8bAdcBobA0HSCz/preview?usp=sharing';
  return (
    <FooterWrapper>
      Copyright
      <BuildVersion />
      <a href={linkPrivacidade} target="_blank" rel="noreferrer">
        Política de Privacidade
      </a>
    </FooterWrapper>
  );
}

export default Footer;
